// Procedure code and modifier for a visit, from the Service Catalog — the one
// rule, shared by the billing wizard, resync and the Monday billing run.
//
// A visit from the unified feed is either an AxisCare visit (service.code is
// AxisCare's label, e.g. "RN - Skilled" or an older alias) or a CAERA visit
// (service.id is the catalog line). Either way the claim line gets the
// catalog's procedure code and modifier. The primary AxisCare code is matched
// before any alias, so a label that is one line's code and another's alias
// resolves to the line that owns it. The Monday run used to try both in one
// pass and could pick the other line (2026-10-19).
//
// No Supabase import: loading the catalog is the caller's job.

export const findCatalogLine = (v, catalog = []) => {
  if (v._source === 'caera' && v.service?.id) return catalog.find(l => l.id === v.service.id) || null;
  const code = v.service?.code;
  if (!code) return null;
  return catalog.find(l => l.axiscare_service_code === code)
      || catalog.find(l => (l.axiscare_service_aliases || []).includes(code))
      || null;
};

// → { service_code, modifier, service_label, source, caera_visit_id, catalog_line }
export const billingCodeFor = (v, catalog) => {
  const line = findCatalogLine(v, catalog);
  const modifiers = line ? [line.modifier1, line.modifier2, line.modifier3].filter(Boolean) : (v.service?.modifier ? [v.service.modifier] : []);
  return {
    service_code: line?.procedure_code || v.service?.procedureCode || '',
    modifier: modifiers.join(':'),
    service_label: v.service?.description || v.service?.name || line?.name || v.service?.code || '',
    source: v._source === 'caera' ? 'caera' : 'axiscare',
    caera_visit_id: v._caera?.visitId || null,
    catalog_line: line,
  };
};

export const visitRef = (v) => (v._source === 'caera' ? `CAERA visit ${v.visitId || ''}` : `AxisCare visit ${v.visitId || ''}`);
